import get from "lodash/get";
const Transformers = {
  getExcelRow: (arr, row) => {
    const excelRow = arr.map((item) => {
      let that = get(row, item);

      // hack for [last] item
      if (item.includes("last")) {
        const name = item.split("[last]")[0];
        const size = get(row, name).length;
        const newItem = item.replace("last", size - 1);
        that = get(row, newItem);
      }
      if (that) {
        return that;
      }
      return "";
    });

    return excelRow;
  },
};

export default Transformers;
